export default "__VITE_ASSET__DbY0mrXm__"